import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Modal, Row } from "react-bootstrap";
import { academydetail, academylist, feedashcount, feeinvoicedelete, feeinvoicelist } from "../../../services/admin";
import moment from "moment";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function AllFee() {
  const navigate = useNavigate();
  const [feedata, setFeeData] = useState([]);
  const [feelist, setFeeList] = useState([]);
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [fdate, setFDate] = useState("");
  const [tdate, setTDate] = useState("");

  const [academy, setAcademy] = useState("");

  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
              }
            }

          }
        }
      });

      academydetail(localStorage.getItem("AAcademy")).then((res) => {
        if (res.status === true) {
          if (res.data.details.name !== null) {
            setAcademy(res.data.details);
          } else {
            setAcademy("");
          }
        }
      });
    }
    // if (localStorage.getItem("ADate") !== '') {
    //   setFDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    //   setTDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    //   listall("", moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));

    // } else {
    //   setFDate(moment(new Date()).format("YYYY-MM-DD"));
    //   setTDate(moment(new Date()).format("YYYY-MM-DD"));
    //   listall("", moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"));

    // }
    const aDate = localStorage.getItem("ADate");

    if (aDate) {
      // From date = 1st day of ADate month
      const fromDate = moment(aDate).startOf("month").format("YYYY-MM-DD");

      // To date = ADate
      const toDate = moment(aDate).format("YYYY-MM-DD");

      setFDate(fromDate);
      setTDate(toDate);

      listall("", fromDate, toDate);

    } else {
      // From date = 1st day of current month
      const fromDate = moment().startOf("month").format("YYYY-MM-DD");

      // To date = today
      const toDate = moment().format("YYYY-MM-DD");

      setFDate(fromDate);
      setTDate(toDate);

      listall("", fromDate, toDate);
    }



  }, []);

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e, fdate, tdate);
    } else {
      setAcaID("");
      listall("", fdate, tdate);
    }
  }

  function listall(aid, fdte, tdte) {
    if (fdte && tdte && tdte < fdte) {
      toast.error("To Date should not be less than From Date.");
      return;
    }
    setFeeData([]);
    setFeeList([]);
    setFDate(fdte);
    setTDate(tdte);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("from_date", fdte);
    temp.append("to_date", tdte);
    if (localStorage.getItem("Role") == "4") {
      temp.append("student", localStorage.getItem("UID"));
    }
    feedashcount(temp).then((res) => {
      if (res.status === true) {
        setFeeData(res.data.counts);
        if (res.data.details.length > 0) {
          const cdata = res.data.details.map((item) => {
            return {
              ...item,
              inv_date: item.paid_date,
              paid_date: item.paid_date ? moment(item.paid_date).format("DD-MM-YYYY") : "",
              student_name: item.student_name + " - " + item.full_name
            }
          });
          console.log(cdata);
          setFeeList(cdata);
        }
      }
    })
  }

  function viewshow(vid) {
    navigate("/feemodule/feesummary/" + vid);
  }

  const cardColors = ['I-st', 'II-st', 'III-st', 'VII-st'];

  const columnDefs = [
    {
      headerName: "Action",
      width: 120,
      field: "fee_struct_id",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      hide: !(localStorage.getItem("Role") == 1 || localStorage.getItem("Role") == 2),
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a onClick={() => viewshow(params.value)}
              title="View Summary"
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-eye"></i>
            </a>
            <a title='Invoice Bill' onClick={() => checkinv(params.data.student_id, params.data.inv_date)}
              // onClick={() => navigate(`/feemodule/invoice/${params.data.student_id}/${params.data.inv_date}`)}
              className="btn-sm btn-info me-2"
            >
              <i className="fas fa-file-invoice"></i>
            </a>
            <a title='Cancel Bill' onClick={() => deletebill(params.data.id)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash"></i>
            </a>
          </div>
        );
      }
    },
    {
      headerName: "Date",
      field: "paid_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },
    {
      headerName: "Academic Year",
      field: "aca_year",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },
    {
      headerName: "Name",
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Total Amount",
      field: "amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Paid Amount",
      field: "paid_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Discount Amount",
      field: "disc_amt",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Fee Type",
      field: "fee_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Month",
      field: "fee_month",
      // Show the fee's month/year (e.g. "May 2026"); blank for one-time fees.
      valueGetter: (p) =>
        p.data.fee_month ? moment(p.data.fee_month, "YYYY-MM").format("MMMM YYYY") : "",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Paid By",
      field: "paid_by",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];
  const [show, setShow] = useState(false);
  const [invdata, setInvData] = useState([]);
  const [invno, setInvNo] = useState("");
  const checkinv = (did, ddate) => {
    const temp = new FormData();
    temp.append("student_id", did);
    temp.append("payment_date", ddate);
    feeinvoicelist(temp).then((res) => {
      if (res.status === true) {
        if (res.status === true && Array.isArray(res.data) && res.data.length > 0) {
          setShow(true);
          setInvData(res.data);
          setInvNo(res.data[0]);
        } else {
          // handle empty or invalid data here
        }
      }
    });
  }

  function deletebill(did) {
    Swal.fire({
      text: "Are you sure want to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        feeinvoicedelete(did).then((response) => {
          if (response.status === true) {
            toast.success(response.message);
            listall(acaid, fdate, tdate);
          }
        })
      }
    });
  }
  const printRef = useRef();
  const cellStyle = {
    border: "1px solid #ccc",
    padding: "8px",
  };
  const handlePrinting = () => {
    // window.print();
    setShow(false);
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open('', '', 'height=700,width=900');
    printWindow.document.write(`
      <html>
        <head>
          <title>Fee Receipt</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            .receipt {
              width: 600px;
              margin: 0 auto;
              border: 1px solid #ccc;
              padding: 20px;
            }
              .avatar-upload .avatar-preBoopathi img{
              text-align: center;
              }
            h2, p {
              text-align: center;
              margin: 0;
              padding: 5px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #ccc;
              padding: 8px;
              text-align: left;
            }
            .total {
              font-weight: bold;
            }
            .right {
              text-align: right;
            }
            .signature {
              margin-top: 40px;
              text-align: right;
            }
            .note {
              margin-top: 30px;
              font-size: 12px;
            }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    // printWindow.close();

    setTimeout(() => {
      printWindow.close();
    }, 1000);
  };
  const totalAmount = invdata.reduce((total, fee) => total + parseFloat(fee.payment_amount || 0), 0);
  const amountInWords = numberToWords(Math.floor(totalAmount));

  function numberToWords(num) {
    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
      "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty",
      "Sixty", "Seventy", "Eighty", "Ninety"];

    const convertTens = (n) => {
      if (n < 10) return ones[n];
      if (n < 20) return teens[n - 10];
      return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    };

    let result = "";

    if (num >= 1000) {
      const thousands = Math.floor(num / 1000);
      result += convertTens(thousands) + " Thousand ";
      num %= 1000;
    }

    if (num >= 100) {
      result += ones[Math.floor(num / 100)] + " Hundred ";
      num %= 100;
    }

    if (num > 0) {
      if (result !== "") result += "and ";
      result += convertTens(num);
    }

    return result.trim() + " Rupees Only";
  }


  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">All Fee</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Fee Module</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            All Fee
          </li>
        </ol>
      </div>
      <Row className="row-sm mx-0">
        {localStorage.getItem("Role") === "1" && (
          <Col xxl={4} lg={4} md={4}>
            <div className="mb-3">
              <label className="form-label">
                Select Academy
                <span className="text-danger"> *</span>
              </label>
              <Select
                className="default-select"
                placeholder="Select Academy"
                value={acaid}
                options={alist}
                onChange={handleAcademy}
                isSearchable={true}
                isClearable
                hidden
              />

            </div>
          </Col>
        )}
        <Col xxl={4} lg={4} md={4}>
          <label className="form-label">From Date</label>
          <input type="date" className="form-control" onChange={(e) => listall(acaid, e.target.value, tdate)} value={fdate} />
        </Col>
        <Col xxl={4} lg={4} md={4}>
          <label className="form-label">To Date</label>
          <input type="date" className="form-control" onChange={(e) => listall(acaid, fdate, e.target.value)} value={tdate} />
        </Col>

      </Row>


      <div className="row mt-2">
        {feedata.map((item, index) => {
          const cardColorClass = cardColors[index % 4];
          return (
            <div className="col-xl-3 col-md-4" key={index}>
              <div className="card custom-card">
                <div className={`card-bodyy ${cardColorClass}`}>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="product-content">
                        <h3 className="title">
                          <a>{item.fee_type}</a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                  <div className=" col justify-content-center text-center">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{item.total}</a> <p className="text-muted ">Total</p>
                    </h3>
                  </div>

                </div>
              </div>
            </div>
          );
        })
        }
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                  All Fee Details
                </h2>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={feelist}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>

              <Modal size="lg"
                show={show}>
                <Modal.Header>Invoice</Modal.Header>
                <Modal.Body>
                  <div ref={printRef} className="receipt">
                    {/* Header with logo and school name */}
                    <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "20px" }}>
                      <img src={require("../../../assets/images/logo/logo.png")} alt="Logo" style={{ height: "80px" }} />
                      <div>
                        <h2 style={{ margin: 0 }}>{academy.name}</h2>
                        <p style={{ margin: 0 }}>
                          {academy.address}
                        </p>
                      </div>
                    </div>

                    {/* Student Info */}
                    <table style={{ width: "100%", marginBottom: "20px", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td><b>Admission No:</b> {invno.admission_number}</td>
                          <td><b>Student Name:</b> {invno.full_name}</td>
                        </tr>
                        <tr>
                          <td><b>Class:</b> {invno.class_name} - {invno.section_name}</td>
                          <td><b>Roll No:</b>{invno.roll_number}</td>
                        </tr>
                        <tr>
                          <td><b>Receipt No:</b> {invno.inv_no}</td>
                          <td><b>Receipt Date:</b> {moment(invno.payment_date).format("DD-MM-YYYY")}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Fee Details */}
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f2f2f2" }}>
                          <th style={{ border: "1px solid #ccc", padding: "8px" }}>Particulars</th>
                          <th style={{ border: "1px solid #ccc", padding: "8px" }}>Amount (₹)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invdata.map((fee, index) => (
                          <tr key={index}><td style={cellStyle}>{fee.fee_type}{fee.fee_month ? " (" + moment(fee.fee_month, "YYYY-MM").format("MMMM YYYY") + ")" : ""}</td><td style={cellStyle}>{parseFloat(fee.payment_amount).toFixed(2)}</td></tr>

                        ))}
                        <tr style={{ fontWeight: "bold" }}>
                          <td style={cellStyle}>Total</td>
                          <td style={cellStyle}> {invdata
                            .reduce((total, fee) => total + parseFloat(fee.payment_amount || 0), 0)
                            .toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>

                    <p style={{ marginTop: "20px" }}><b>In Words:</b> {amountInWords}</p>
                    <p><b>Payment Mode:</b> Cash</p>
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "30px",
                    }}>
                      <p style={{ fontWeight: "bold", margin: 0, fontSize: "14px" }}>
                        Please note: Paid fees will not be refunded under any circumstances.
                      </p>

                      <b>Signature</b>
                    </div>


                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={() => setShow(false)}>
                    Close
                  </a>
                  <button className="btn btn-success" onClick={handlePrinting}>
                    Print
                  </button>
                </Modal.Footer>
              </Modal>
              {/* <div className="table-responsive tasks">
                <table className="table card-table table-vcenter mb-0  border">
                  <thead>
                    <tr>
                      <th className="text-center">Date</th>
                      <th className="text-center">Name</th>
                      <th className="text-center">Paid Amount</th>
                      <th className="text-center">
                        Pending Amount
                      </th>
                      <th className="text-center">Fee Type</th>
                      <th className="text-center">Paid By</th>
                      {localStorage.getItem("Role") === "1" && (
                        <th className="text-center">Action</th>

                      )

                      }

                    </tr>
                  </thead>
                  <tbody>
                    {feelist.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className="text-center">
                            {moment(item.paid_date).format("DD-MM-YYYY")}
                          </td>
                          <td className="text-center">
                            {item.student_name} - {item.full_name}
                          </td>
                          <td className="text-center">
                            {item.paid_amount}
                          </td>
                          <td className="text-center">
                            {item.pending_amount}
                          </td>
                          <td className="text-center">
                            {item.fee_type}
                          </td>

                          <td className="text-center">
                            {item.paid_by}
                          </td>
                          {localStorage.getItem("Role") === "1" && (
                            <td className="text-center">
                              <a
                                onClick={() => viewshow(item.id)}
                                title="View Summary"
                                className="btn-sm btn-info"
                              >
                                <i className="fa fa-eye"></i>
                              </a>
                            </td>
                          )
                          }

                        </tr>
                      )
                    })

                    }


                  </tbody>
                </table>
              </div> */}


            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
